/**
 * @generated SignedSource<<06f964e81a601a9c0425b3a3e4b2c586>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamSelectList_Team$data = ReadonlyArray<{
  readonly id: string;
  readonly isPrivate: boolean;
  readonly name: string;
  readonly " $fragmentSpreads": FragmentRefs<"TeamSelectListItem_Team">;
  readonly " $fragmentType": "TeamSelectList_Team";
}>;
export type TeamSelectList_Team$key = ReadonlyArray<{
  readonly " $data"?: TeamSelectList_Team$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamSelectList_Team">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "TeamSelectList_Team",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isPrivate",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TeamSelectListItem_Team"
    }
  ],
  "type": "Team",
  "abstractKey": null
};

(node as any).hash = "dc549cf3216d1a9e991dab0beb05636e";

export default node;
